import { MINUTES } from '@sequencehq/utils/dates'

/** Minimum characters before searches fire. */
export const CUSTOMER_MIN_CHARS = 2

/** Shown in the search input and as the initial empty-state hint. */
export const SEARCH_PLACEHOLDER = 'Search for customers and invoices'

/** Customer results shown per search. Excess matches are dropped — the
 * customers list has no name-or-alias search to "see all" into. */
export const RESULT_LIMIT = 10

/** Invoice results per search. No "see all" page exists, so we fetch more and let the list scroll. */
export const INVOICE_RESULT_LIMIT = 20

/**
 * Debounce before firing searches. The customer and invoice list endpoints are
 * heavy, so we wait for a clear pause in typing before hitting them.
 */
export const SEARCH_DEBOUNCE_MS = 400

/** Re-running a recent search within this window is served from cache. */
export const SEARCH_STALE_TIME = 1 * MINUTES

/**
 * PostHog event fired when a constituent search query resolves, tagged with
 * the `queryType` below. Lets us track per-query resolution time (to spot a
 * slow query) and overall search usage.
 */
export const SEARCH_QUERY_RESOLVED_EVENT = 'global_search_query_resolved'
